import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/core/services/sidenav/sidenav.service';
import { SideMenuItems } from 'src/app/shared/models/side-menu-items/side-menu-items';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
/**
 * Side menu
 */
export class SideMenuComponent {
  @Input() sideMenuItems: SideMenuItems = new SideMenuItems();
  RoutesKeys = RoutesKeys;
  /**
   * @constructor
   */
  constructor(private sideNavService: SidenavService, private router: Router) {}

  /**
   * Closes side menu
   */
  onClose() {
    this.sideNavService.toggle();
  }

  /**
   * Navigate to router
   * @param {RoutesKeys} route
   */
  onRoute(route: RoutesKeys) {
    this.router.navigate([route]);
  }
}
